import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageIntro from "@/components/feature/PageIntro";
import { Link } from "react-router-dom";
const guides = [
  {
    title: "Plan your learning journey",
    intro:
      "Start with the capability you want to build, then consider the kind of learning that fits your circumstances.",
    questions: [
      "What would you like to understand or do more confidently?",
      "How much time can you realistically set aside each week?",
      "Would online or in-person learning suit you better?",
      "What do you need to know about fees, equipment, and support before joining?",
    ],
    link: "/trading-academy#apply",
    action: "Register academy interest",
  },
  {
    title: "Prepare an enterprise conversation",
    intro:
      "A concise picture of your business or idea helps make the first conversation more useful.",
    questions: [
      "Who does your enterprise serve, and what problem does it address?",
      "What stage are you at, and what is the next practical milestone?",
      "What skills, relationships, or resources are missing?",
      "How could your idea strengthen local ownership and economic participation?",
    ],
    link: "/advisory#consult",
    action: "Discuss your goals",
  },
  {
    title: "Shape a meaningful partnership",
    intro:
      "Start with a shared purpose and a clear understanding of what each partner can contribute.",
    questions: [
      "Which community or group would the collaboration serve?",
      "How will local participants help define the priorities?",
      "What could each organization contribute?",
      "What would a realistic first step look like, and how would you assess it?",
    ],
    link: "/partnerships#partner-form",
    action: "Explore a partnership",
  },
];
export default function InsightsPage() {
  return (
    <>
      <Navbar />
      <main id="main-content">
        <PageIntro
          eyebrow="Insights & resources"
          title="Good questions. Clearer next steps."
        >
          <p>
            Use these starting points to prepare for a conversation about
            education, enterprise, or collaboration. No specialist background
            required.
          </p>
        </PageIntro>
        <section className="section-space">
          <div className="shell guide-grid">
            {guides.map((g) => (
              <article className="guide-card" key={g.title}>
                <h2>{g.title}</h2>
                <p className="body-copy">{g.intro}</p>
                <ul>
                  {g.questions.map((q) => (
                    <li key={q}>{q}</li>
                  ))}
                </ul>
                <Link className="text-link" to={g.link}>
                  {g.action} <span aria-hidden="true">↗</span>
                </Link>
              </article>
            ))}
          </div>
        </section>
        <section className="section-space bg-[#F8F6F3]">
          <div className="shell purpose-grid">
            <div>
              <p className="eyebrow">Looking ahead</p>
              <h2>A growing resource library.</h2>
            </div>
            <div>
              <p className="body-copy">
                We plan to add financial literacy materials, enterprise guides,
                workforce insights, and perspectives on diaspora collaboration
                as our programs develop. Webinars, courses, and downloadable
                publications will be listed when they are ready.
              </p>
              <p className="body-copy">
                Subscribe below for updates, or tell us which topics would be
                useful to you.
              </p>
              <Link className="text-link" to="/contact#contact-form">
                Suggest a topic <span aria-hidden="true">↗</span>
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
